import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup-content bg-white p-4 pt-0 rounded-custom" }
const _hoisted_2 = { class: "popup-header-wrapper pb-1" }
const _hoisted_3 = { class: "popup-header pt-4 d-flex justify-content-between align-items-start" }
const _hoisted_4 = { class: "popup-title title-2" }

import PopupBase from "@/vue/common/popupBase.vue";
import EcoActions from "@/vue/responsible-stay/components/EcoActions.vue";
import RSEblock from "@/vue/responsible-stay/components/RSEblock.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EcoPopup',
  props: {
  isOpen: Boolean,
  title: String,
  isCriteriaFloconVert: Boolean,
  isCriteriaCleVerte: Boolean,
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const close = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupBase, {
    open: __props.isOpen,
    onClosePopup: close,
    fullHeight: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1),
            _createElementVNode("button", {
              class: "close-btn top-0 end-0 p-2",
              onClick: close
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                width: "22",
                height: "22"
              }, [
                _createElementVNode("use", { "xlink:href": "#___icon___close-x" })
              ], -1)
            ]))
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "separator border-bottom my-2" }, null, -1))
        ]),
        _createVNode(EcoActions, {
          isCriteriaFloconVert: __props.isCriteriaFloconVert,
          isCriteriaCleVerte: __props.isCriteriaCleVerte
        }, null, 8, ["isCriteriaFloconVert", "isCriteriaCleVerte"]),
        _createVNode(RSEblock, {
          isCriteriaFloconVert: __props.isCriteriaFloconVert,
          isCriteriaCleVerte: __props.isCriteriaCleVerte
        }, null, 8, ["isCriteriaFloconVert", "isCriteriaCleVerte"])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})